<template>
	<fieldset
		class="checkbox"
    :class="{
			'checkbox--inline': inline
		}"
	>
    <legend v-if="legend">
      <span v-sanitize="legend"/>
      <span
        v-if="legendOption"
        class="optional"
        v-sanitize="legendOption"
      />
    </legend>
		<div
			v-for="(option, index) in options"
			:key="option.value"
			class="checkbox-area"
			:class="{
				'checkbox-area--block': vertical
			}"
		>
			<input
				type="checkbox"
				:id="`${uniqueId}-${index}-${option.value}`"
				:name="name"
				:required="required"
				:value="option.value"
				@change="onChange"
				:checked="Array.isArray(value) ? value.includes(option.value) : false"
				:disabled="disabled"
				autocomplete="off"
			>
			<label
				:for="`${uniqueId}-${index}-${option.value}`"
				v-html="option.label"
			/>
		</div>
	</fieldset>
</template>

<script>

export default {
	props: {
		name: String,
		legend: String,
		legendOption: String,
		required: Boolean,
		value: {
      type: Array,
      default: () => []
    },
		options: Array,
		vertical: Boolean,
		inline: Boolean,
		disabled: Boolean
	},
	data() {
		return {
			uniqueId: `${this.name}-${(Date.now().toString(36) + Math.random().toString(36).substring(2, 7))}`,
		}
	},
	methods: {
		onChange(e) {
      const checked = this.value || []
      if (e.target.checked && !checked?.includes(e.target.value)) {
        checked?.push(e.target.value)
      } else if (!e.target.checked && checked?.includes(e.target.value)) {
        const index = checked?.indexOf(e.target.value)
        checked?.splice(index, 1)
      }

			this.$emit('input', checked);
		}
	}
}
</script>

<style>

</style>
